<script>
import axios from 'axios'

export default {}

export const CampaignAPI = axios.create({
  baseURL: process.env.CC_CAMPAIGN_API
})
</script>



// WEBPACK FOOTER //
// src/components/CampaignAPI.vue